export type workflowDataType = {
  inactive?: boolean;
  updateConnectionType?: boolean;
  user?: Partial<UserType>;
  users?: { [k: string]: UserType };
  schedule?: { [k: string]: scheduleType };
};

export type hoursType = { Start: string | undefined; End: string | undefined };

export type UserType = {
  BubbleColor?: string;
  ConnectionId: string;
  ConnectionType: ConnectionType;
  Group: LobbyType;
  Id: string;
  Lunch?: hoursType;
  Shift?: hoursType;
  Name: string;
  Scores?: {
    [key: number]: number;
  };
  Status?: number;
  StatusMessage?: string;
};

export type scheduleType = {
  Id: string;
  Name: string;
  Shift?: hoursType;
  Lunch?: hoursType;
  IsCoordinator: boolean;
};
export enum agentStatusType {
  Ready,
  Away
}

export enum agentScoresType {
  Booked,
  Changed,
  Options,
  Canceled,
  Actions
}

export enum folioScoresType {
  Merged,
  Invoiced,
  Requested
}
export enum LobbyType {
  Inbox,
  Folio
}

export enum ConnectionType {
  Spectator,
  Coordinator,
  Active,
  Lobby
}
